// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"312":"1b26ffe8","338":"52c2307e"}[chunkId] + "." + {"312":"95481fd6a9ef4599","338":"2fda75d70b0c9bf3"}[chunkId] + ".js";
};